import api from './api';

// Get content by slug (public)
export const getContentBySlug = async (slug) => {
    try {
        const response = await api.get(`/content/${slug}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching content by slug:', error);
        throw error;
    }
};

// Get all published content (public)
export const getPublishedContent = async (contentType = null) => {
    try {
        const params = new URLSearchParams();
        if (contentType) {
            params.append('contentType', contentType);
        }
        
        const response = await api.get(`/content?${params}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching published content:', error);
        throw error;
    }
};

// Get all content for admin
export const getAdminContent = async (token, contentType = null) => {
    try {
        const params = new URLSearchParams();
        if (contentType) {
            params.append('contentType', contentType);
        }
        
        const response = await api.get(`/content/admin/all?${params}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching admin content:', error);
        throw error;
    }
};

// Get content by ID (admin)
export const getContentById = async (id, token) => {
    try {
        const response = await api.get(`/content/admin/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching content by ID:', error);
        throw error;
    }
};

// Create content
export const createContent = async (contentData, token) => {
    try {
        const response = await api.post('/content/admin', contentData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error creating content:', error);
        throw error;
    }
};

// Update content
export const updateContent = async (id, contentData, token) => {
    try {
        const response = await api.put(`/content/admin/${id}`, contentData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating content:', error);
        throw error;
    }
};

// Delete content
export const deleteContent = async (id, token) => {
    try {
        const response = await api.delete(`/content/admin/${id}/delete`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting content:', error);
        throw error;
    }
};

// Bulk upload content from CSV/Google Sheets
export const bulkUploadContent = async (contentData, token) => {
    try {
        const response = await api.post('/content/admin/bulk-upload', { contentData }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error bulk uploading content:', error);
        throw error;
    }
};

// Bulk create initial content
export const bulkCreateContent = async (token) => {
    try {
        const response = await api.post('/content/admin/bulk-create', {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error bulk creating content:', error);
        throw error;
    }
};
